import React, { useEffect } from 'react';

const PreloadImage = ({ src, alt, ...props }) => {
  useEffect(() => {
    // Dynamically create and add a preload <link> tag
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    link.fetchpriority = 'high'; // Add fetchpriority to the preload link

    // Append the link to the <head> to start preloading
    document.head.appendChild(link);

    return () => {
      // Cleanup the <link> when the component unmounts
      document.head.removeChild(link);
    };
  }, [src]);

  return <img src={src} alt={alt} fetchpriority="high" {...props} />;
};

export default PreloadImage;
